import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Modal,
  Navbar,
  Row,
  Table,
} from 'reactstrap';
import { CircularProgress, IconButton, Tooltip } from '@material-ui/core';
import './style.css';

import formatCurrency from 'utils/formatCurrency';
import { PropostaVersao } from 'models/PropostaVersao';
import React, { useContext, useEffect, useState } from 'react';
import api from 'services/api';
import { PropostaVersaoParcelas } from 'models/PropostaVersaoParcelas';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';
import {
  FaCalculator,
  FaEye,
  FaEyeSlash,
  FaInfoCircle,
  FaPlusCircle,
  FaTrash,
} from 'react-icons/fa';
import arredondaCentesimal from 'utils/arredondaCentesimal';
import FloatingButton from 'components/FloatingButton';
import { Container } from 'components/FloatingButton/styles';
import verificaSaoIguaisComMargemErro from 'utils/verificaSaoIguaisComMargemErro';
import { Th, Td } from './styles';
import { PropostaContext } from '../..';
import Parcelas from '../Precificacao/components/Parcelas';
import { iPropostaDados } from '../Precificacao';
import SelecaoArredondamento from '../Precificacao/components/SelecaoArredondamento';

registerLocale('pt-BR', ptBr);

interface Resultados {
  propostaVersao: PropostaVersao;
  apenasSintetica: boolean;
}

interface ResultadoSintetica {
  conta: string;
  valor: number;
  percentualROL: number;
  limitar: boolean;
}

interface RetornoTabela {
  editavel: boolean;
  valor: number | null;
  valorBase: number | null;
  percentualMaterialServico: number | null;
  percentualROL: number | null;
  titulo: string;
  produtoId: number | null;
  isTotal: boolean;
}

interface RetornoAnaliticaFinal {
  conta: string;
  limitar: boolean;
  tabelas: RetornoTabela[];
}

interface RetornoAnaliticaNovo {
  item: string;
  limitar: boolean;
  visivel: boolean;
  tabelas: {
    titulo: string;
    valor: number;
    percentualROL: number;
    percentualROB: number;
  }[];
}

interface ResultadoVisaoPorAtividade {
  codigoAtividade: string;
  descricaoAtividade: string;
  bdiTotal: number;
  precoBruto: number;
  precoLiquido: number;
  custoMateriais: number;
  percentualROL: number;
  demaisCV: number;
  margemCont: number;
  percentualMargemROL: number;
  abcFat: number;
  isTotalRow: boolean;
}

interface iPropostaVersaoParcelas {
  id: number;
  meioPagamentoId: number;
  dataPrevista?: Date | null | string;
  percentual: number;
  valor: number;
  observacao: string;
}

interface IMateriaisServico {
  valor: number;
  percentual: number;
  produtoId: number;
  titulo: string;
}

/**
 *
interface iPropostaVersaoParcelas extends PropostaVersaoParcelas {
  dias?: number;
  calculo?: number;
}
*/

interface iAcessoPrograma {
  programa: number;
  acessoLimitado: boolean;
  temAcesso: boolean;
}

// 80 Proposta - Analisador - Editar Data Embarque
// 81 Proposta - Analisador - Editar Juros
// 82 Proposta - Analisador - Editar Dias Data Juros
// 83 Proposta - Analisador - Visualização completa de tabelas

export default function Resultados({
  propostaVersao,
  apenasSintetica,
}: Resultados): JSX.Element {
  const CONTA_PROD = 'Prod/Mat/Mercad';
  const CONTA_SERV = 'Servico/Engenh/Proj';

  const { carregaPropostaVersao, meioPagamentos } = useContext(PropostaContext);

  const [resultadoSintetica, setResultadoSintetica] = useState<
    RetornoAnaliticaFinal[]
  >([]);
  const [resultadoAnalitica, setResultadoAnalitica] = useState<
    RetornoAnaliticaNovo[]
  >([]);
  const [resultadoAtividade, setResultadoAtividade] = useState<
    ResultadoVisaoPorAtividade[]
  >([]);
  const [isLoadingSintetica, setIsLoadingSintetica] = useState(false);
  const [isLoadingAnalitica, setIsLoadingAnalitica] = useState(false);
  const [isLoadingAtividade, setIsLoadingAtividade] = useState(false);
  const [isLoadingPrazoMedio, setIsLoadingPrazoMedio] = useState(false);
  const [recalcularCustoFinanceiro, setRecalcularCustoFinanceiro] =
    useState(false);

  const [valoresDiferentes, setValoresDiferentes] = useState(false);

  const [precisaSalvar, setPrecisaSalvar] = useState(false);

  const [tabelasLimitadas, setTabelasLimitadas] = useState(false);

  const [isAtingirMeta, setIsAtingirMeta] = useState(false);
  const [isAtingirMetaEbitda, setIsAtingirMetaEbitda] = useState(false);

  const [dadosBasicosCarregados, setDadosBasicosCarregados] = useState(false);

  const [acessoProgramas, setAcessosProgramas] = useState<iAcessoPrograma[]>(
    [] as iAcessoPrograma[],
  );
  const [jurosMensal, setJurosMensal] = useState(0);
  const [diasSomar, setDiasSomar] = useState(0);
  const [diasAntesEmbarque, setDiasAntesEmbarque] = useState(0);
  const [diasParaEmbarque, setDiasParaEmbarque] = useState(0);
  const [PMR, setPMR] = useState(0);
  const [dataEmbarque, setDataEmbarque] = useState<any>();
  const [dataBaseJurosEmbarque, setDataBaseJurosEmbarque] = useState<string>();
  const [isSaving, setIsSaving] = useState(false);

  const [metaDesconto, setMetaDesconto] = useState(
    propostaVersao?.desconto ?? 0,
  );
  const [metaValor, setMetaValor] = useState(
    formatCurrency(propostaVersao?.valorFinal ?? 0, 2),
  );
  const [metaEbitda, setMetaEbitda] = useState(0);
  const [arredondamentoProposta, setArredondamentoProposta] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [descontoMaximo, setDescontoMaximo] = useState<number | null>(null);

  const [propostaVersaoParcelas, setPropostaVersaoParcelas] = useState<any[]>(
    [],
  );

  const [isModoSimulacao, setIsModoSimulacao] = useState(false);
  const [parcelasModificadas, setParcelasModificadas] = useState(false);
  const [custoChanged, setCustoChanged] = useState(false);

  const [informacaoProposta, setInformacaoProposta] =
    useState<iPropostaDados>();
  const [custoFinanceiro, setCustoFinanceiro] = useState(0);
  const [comissao, setComissao] = useState(0);
  const [materialServicoVlrMudou, setMaterialServicoVlrMudou] = useState(false);
  const [isPrecificacaoLegacy, setIsPrecificacaoLegacy] = useState(false);

  const [isModoSimulacaoForm, setIsModoSimulacaoForm] = useState(false);

  function quaseIgual(a: number, b: number, tolerancia = 0.00001) {
    if (b > a) return Math.abs(b - a) <= tolerancia;
    return Math.abs(a - b) <= tolerancia;
  }

  // Valor/Porcentagem de materiais e serviços são proporcionais
  function handleChangePercentual(
    linhaIndex: number,
    tabelaIndex: number,
    percentual: number,
  ) {
    setMaterialServicoVlrMudou(true);
    setResultadoSintetica(prev => {
      const linhaEditada = prev[linhaIndex];
      const contaEditada = linhaEditada.conta;

      // soma do valorBase das duas contas
      const valorBaseTotal = prev.reduce((total, linha) => {
        if (linha.conta === CONTA_PROD || linha.conta === CONTA_SERV) {
          return total + (linha.tabelas[tabelaIndex]?.valorBase ?? 0);
        }
        return total;
      }, 0);

      // se não tem base, não faz nada
      if (valorBaseTotal === 0) return prev;

      return prev.map(linha => {
        if (linha.conta !== CONTA_PROD && linha.conta !== CONTA_SERV) {
          return linha;
        }

        const percentualFinal =
          linha.conta === contaEditada ? percentual : 100 - percentual;

        return {
          ...linha,
          tabelas: linha.tabelas.map((t, j) => {
            if (j !== tabelaIndex) return t;

            const novoValor = null;
            // const novoValor = (valorBaseTotal * percentualFinal) / 100;

            return {
              ...t,
              percentualMaterialServico: percentualFinal,
              valor: novoValor,
            };
          }),
        };
      });
    });
  }

  async function handleChange(newObject: iPropostaDados) {
    // setPropostaVersaoParcelas(newObject.parcelas);

    /**
     *

    const novoObj: iPropostaDados = {
      ...newObject,
      parcelas: propostaVersaoParcelas
    }
    */
    setInformacaoProposta(newObject);
    // sempre que houver mudanças aqui, vou desabilitar o botão de salvar. O usuário precisa calcular primeiro
    // setEnableSaveButton(false);
  }

  async function buscarListaDescontos() {
    if (!propostaVersao) return;

    const response2 = await api.get(
      `/proposta-perfil-aprovacao/min-max-desconto/${propostaVersao.id}`,
    );

    setDescontoMaximo(response2.data?.descontoMaximo ?? 0);
  }

  async function carregarDadosSintetica() {
    try {
      setIsLoadingSintetica(true);
      const metaValorValue = Number(
        String(metaValor ?? '0')
          .replace('R$', '')
          .trim()
          .replaceAll('.', '')
          .replaceAll(',', '.'),
      );
      const response = await api.get(
        `/proposta-resultado/sintetica?versaoId=${propostaVersao.id}&isAtingirMeta=${isAtingirMeta}&custoModificado=${custoChanged}&novoCusto=${custoFinanceiro}&metaValor=${metaValorValue}`,
      );

      const sintetica: RetornoAnaliticaFinal[] = response.data;

      setResultadoSintetica(
        sintetica.map(item => {
          return {
            ...item,
            tabelas: item.tabelas.reverse(),
          };
        }),
      );

      return response.data as RetornoAnaliticaFinal[];
    } finally {
      setIsLoadingSintetica(false);
    }
  }

  async function carregarDadosAnalitica() {
    try {
      setIsLoadingAnalitica(true);
      const metaValorValue = Number(
        String(metaValor ?? '0')
          .replace('R$', '')
          .trim()
          .replaceAll('.', '')
          .replaceAll(',', '.'),
      );
      const response = await api.get(
        `/proposta-resultado/analitica?versaoId=${propostaVersao.id}&isAtingirMeta=${isAtingirMeta}&custoModificado=${custoChanged}&novoCusto=${custoFinanceiro}&metaValor=${metaValorValue}`,
      );

      const analit = response.data as RetornoAnaliticaNovo[];

      setResultadoAnalitica(
        analit.map(item => {
          return {
            ...item,
            tabelas: item.tabelas.reverse(),
          };
        }),
      );
    } finally {
      setIsLoadingAnalitica(false);
    }
  }

  async function carregarDadosAtividade() {
    try {
      setIsLoadingAtividade(true);
      const metaValorValue = Number(
        String(metaValor ?? '0')
          .replace('R$', '')
          .trim()
          .replaceAll('.', '')
          .replaceAll(',', '.'),
      );
      const response = await api.get(
        `/proposta-resultado/atividade?versaoId=${propostaVersao.id}&isAtingirMeta=${isAtingirMeta}&custoModificado=${custoChanged}&novoCusto=${custoFinanceiro}&metaValor=${metaValorValue}`,
      );

      setResultadoAtividade(
        (response.data.retorno as ResultadoVisaoPorAtividade[]) ?? [],
      );
    } finally {
      setIsLoadingAtividade(false);
    }
  }

  async function carregarDadosBasicos() {
    setDadosBasicosCarregados(false);
    const response = await api.get(
      `/proposta-resultado/prazo-medio?versaoId=${propostaVersao.id}`,
    );

    setIsPrecificacaoLegacy(response.data.isPrecificacaoLegacy);

    const vDataEmbarque = new Date(
      `${String(response.data.dataEmbarque).split('T')[0]}T10:10:10`,
    );

    vDataEmbarque.toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });

    const vDataJuros = new Date(vDataEmbarque);

    vDataJuros.setDate(
      vDataJuros.getDate() - (response.data.diasAntesEmbarque ?? 0),
    );

    const diferenca = new Date(vDataEmbarque).getTime() - new Date().getTime();

    let diferencaFinal = 0;

    if (diferenca > 0) diferencaFinal = diferenca / (1000 * 3600 * 24);

    const dataE = `${vDataEmbarque.getFullYear()}-${String(
      vDataEmbarque.getMonth() + 1,
    ).padStart(2, '0')}-${String(vDataEmbarque.getDate()).padStart(2, '0')}`;

    const dataJ = vDataJuros.toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });

    setPrecisaSalvar(response.data.existemDados === false);
    setDataBaseJurosEmbarque(dataJ);
    setDiasParaEmbarque(Math.ceil(diferencaFinal));
    setDataEmbarque(new Date(`${dataE}T10:10:10`));
    setJurosMensal(response.data.jurosMensal ?? 0);
    setDiasAntesEmbarque(response.data.diasAntesEmbarque ?? 0);
    setDiasSomar(response.data.diasSomar ?? 0);
    setDadosBasicosCarregados(true);
  }

  async function getAcessoPrograma() {
    const response = await api.get('/acesso-programa/acesso-programa-lote', {
      params: {
        programas: [80, 81, 82, 83, 131],
      },
    });

    const lista = response.data as iAcessoPrograma[];

    const acessoLimitadoTabela = !lista.find(
      item =>
        item.programa === 83 &&
        item.temAcesso === true &&
        item.acessoLimitado === false,
    );

    setTabelasLimitadas(acessoLimitadoTabela);

    setAcessosProgramas(lista);
    // setAcessoPrograma(response.data);
  }

  async function dadosProposta() {
    const response = await api.get(
      `/proposta-precificacao/versao/${propostaVersao.id}`,
    );

    const proposta = response.data as iPropostaDados;

    setInformacaoProposta(proposta);
    setCustoFinanceiro(proposta.variaveisComerciais.custoFinanceiro);
    setComissao(proposta.valores.percentualComissao);
  }

  function formatarParcelas(parcelasArr: any[]) {
    return parcelasArr.map((parcelaVal: any) => {
      return {
        id: parcelaVal.id,
        meioPagamentoId: parcelaVal.meioPagamentoId,
        dataPrevista: parcelaVal.dataPrevista ?? null,
        percentual: parcelaVal.percentual ?? 0,
        valor: parcelaVal.valor ?? 0,
        observacao: parcelaVal.observacao ?? '',
      };
    });
  }

  useEffect(() => {
    getAcessoPrograma();
  }, []);

  /**
   *
  async function carregarParcelas() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/parcelas`,
    );
    setPropostaVersaoParcelas(response.data as iPropostaVersaoParcelas[]);
    setParcelasModificadas(false);
  }
  */

  async function calcularParcelas(dataEmb: string, filtro = 0) {
    const parcelas = informacaoProposta?.parcelas ?? [];
    // const parcelas = propostaVersaoParcelas;

    if (!dataEmb) return [];

    return parcelas
      ?.filter(
        (item: any) =>
          item.meioPagamentoId === (filtro > 0 ? filtro : item.meioPagamentoId),
      )
      ?.map((item: iPropostaVersaoParcelas) => {
        let diferencaCalcular = 0;

        if (!item.dataPrevista || !dataEmb) diferencaCalcular = 0;
        else {
          const diferenca =
            new Date(
              `${String(item.dataPrevista).split('T')[0]}T10:10:10`,
            ).getTime() - new Date(dataEmb).getTime();

          if (diferenca <= 0) diferencaCalcular = 0;
          else diferencaCalcular = diferenca / (1000 * 3600 * 24);
        }

        const diferencaFinal = Math.floor(diferencaCalcular);

        const divisorFormatado = Number(item.percentual ?? 0) / 100;

        return Math.floor(diferencaFinal * divisorFormatado);
      });
  }

  async function calcularCusto(
    paramJurosMensal: number,
    parcelasCalculadas: number[],
  ): Promise<{
    custo: number;
    pmr: number;
  }> {
    const totalSomaProduto =
      parcelasCalculadas.reduce(
        // eslint-disable-next-line prettier/prettier
        (tot: number, item: number) => tot + item * 100,
        0,
      ) / 100;

    const calculoPMR = totalSomaProduto;

    // const calculoPMR =
    //   totalValorParcelas === (precoBruto?.valor ?? 0) ? totalSomaProduto : 0;

    //= 1*(1+N25)^(P27/30)-1
    const calculoCustoFin =
      1 * (1 + (paramJurosMensal ?? 0) / 100) ** (calculoPMR / 30) - 1;

    const custoFinanceiroFinal = arredondaDecimais(calculoCustoFin * 100, 2);

    return {
      custo: custoFinanceiroFinal,
      pmr: calculoPMR,
    };
  }

  async function carregarDadosPrazoMedio(
    paramJurosMensal: number,
    paramDiasAntesEmbarque: number,
    paramDataBase?: string | null,
  ) {
    setIsLoadingPrazoMedio(true);

    if (!paramDataBase || !paramDataBase) return;

    const isParalelo = propostaVersao.meioPagamentoId === 4;
    // const isParalelo = true;

    if (isParalelo) {
      const parcelasCalculadasRP = await calcularParcelas(paramDataBase, 1);
      const parcelasCalculadasF = await calcularParcelas(paramDataBase, 2);

      const resultCustoRP = await calcularCusto(
        paramJurosMensal ?? 0,
        parcelasCalculadasRP,
      );
      const resultCustoF = await calcularCusto(
        paramJurosMensal ?? 0,
        parcelasCalculadasF,
      );

      const objeto =
        resultCustoRP.custo >= resultCustoF.custo
          ? resultCustoRP
          : resultCustoF;

      if (!informacaoProposta?.outros?.isRegramentoGeral) {
        setCustoFinanceiro(objeto.custo);
      }
      setPMR(objeto.pmr);
    } else {
      const parcelasCalculadas = await calcularParcelas(paramDataBase);
      const resultCusto = await calcularCusto(
        paramJurosMensal ?? 0,
        parcelasCalculadas,
      );
      if (!informacaoProposta?.outros?.isRegramentoGeral) {
        setCustoFinanceiro(resultCusto.custo);
      }
      setPMR(resultCusto.pmr);
    }

    setJurosMensal(paramJurosMensal ?? 0);
    setDiasAntesEmbarque(paramDiasAntesEmbarque ?? 0);
    setRecalcularCustoFinanceiro(false);

    const vDataEmbarque = new Date(paramDataBase);
    const vDataJuros = new Date(paramDataBase);

    vDataJuros.setDate(vDataJuros.getDate() - (paramDiasAntesEmbarque ?? 0));

    const diferenca = new Date(vDataEmbarque).getTime() - new Date().getTime();

    let diferencaFinal = 0;

    if (diferenca > 0) diferencaFinal = diferenca / (1000 * 3600 * 24);

    const dataJuro = vDataJuros.toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });

    setDataEmbarque(paramDataBase);
    setDiasParaEmbarque(Math.ceil(diferencaFinal));
    setDataBaseJurosEmbarque(dataJuro);
    setIsLoadingPrazoMedio(false);
  }

  function atualizarDados(propriedade: string, valor: any) {
    if (propriedade === 'dias_antes_embarque') {
      carregarDadosPrazoMedio(jurosMensal, Number(valor ?? 0), dataEmbarque);
    } else if (propriedade === 'juros_mensal') {
      carregarDadosPrazoMedio(
        Number(valor ?? 0),
        diasAntesEmbarque,
        dataEmbarque,
      );
    } else if (propriedade === 'data_embarque') {
      if (!Number.isNaN(Date.parse(valor)))
        carregarDadosPrazoMedio(jurosMensal, diasAntesEmbarque, valor);
    }
    console.log('entrou atualizarDados');
    setCustoChanged(true);
    setPrecisaSalvar(true);
  }

  async function carregarDadosGerais() {
    await carregarDadosSintetica();
    await carregarDadosAnalitica();
    await carregarDadosAtividade();
  }

  useEffect(() => {
    dadosProposta();
    // carregarParcelas();
    buscarListaDescontos();
    carregarDadosBasicos();
    carregarDadosGerais();
  }, []);

  useEffect(() => {
    if (
      dadosBasicosCarregados === true &&
      informacaoProposta &&
      informacaoProposta.parcelas.length > 0 &&
      resultadoSintetica &&
      resultadoSintetica.length > 0
    ) {
      // setComissao(Number(informacaoProposta?.valores?.percentualComissao) ?? 0);
      const totalParcela = informacaoProposta.parcelas
        .filter((item: any) => item.setorAtividade == null)
        .reduce(
          (total: number, registro: any) =>
            total + (Number(registro.valor) || 0),
          0,
        );

      const totalSintentica =
        resultadoSintetica
          .find(item => item.conta === 'Receita Bruta')
          ?.tabelas.find(val => val.titulo.toUpperCase().trim() === 'TOTAL')
          ?.valor ?? 0;

      const quase = verificaSaoIguaisComMargemErro(
        totalSintentica,
        totalParcela,
      );

      let parcelasDiferentes = totalParcela !== totalSintentica && !quase;
      console.log({
        totalParcela,
        totalSintentica,
        quase,
      });

      const isParalelo = propostaVersao.meioPagamentoId === 4;

      if (isParalelo) {
        const totalRP = informacaoProposta.parcelas
          ?.filter(item => item.meioPagamentoId === 1)
          .reduce((acc, it) => acc + (it.valor ?? 0), 0);

        const totalF = informacaoProposta.parcelas
          ?.filter(item => item.meioPagamentoId === 2)
          .reduce((acc, it) => acc + (it.valor ?? 0), 0);

        parcelasDiferentes =
          totalRP !== totalSintentica || totalF !== totalSintentica;
      }

      setValoresDiferentes(parcelasDiferentes);
    }
  }, [
    resultadoSintetica,
    informacaoProposta?.parcelas,
    dadosBasicosCarregados,
  ]);

  useEffect(() => {
    if (
      dadosBasicosCarregados === true &&
      informacaoProposta &&
      informacaoProposta.parcelas.length > 0 &&
      resultadoSintetica &&
      resultadoSintetica.length > 0 &&
      !resultadoSintetica.find(item => item.conta === 'Ebitda 2')
    ) {
      if (jurosMensal && dataEmbarque) {
        carregarDadosPrazoMedio(jurosMensal, diasAntesEmbarque, dataEmbarque);
      }
    }
  }, [
    resultadoSintetica,
    informacaoProposta?.parcelas,
    dadosBasicosCarregados,
  ]);

  useEffect(() => {
    if (recalcularCustoFinanceiro === true) {
      if (jurosMensal && dataEmbarque) {
        carregarDadosPrazoMedio(jurosMensal, diasAntesEmbarque, dataEmbarque);
      }
    }
  }, [recalcularCustoFinanceiro]);

  async function checkAprovacaoDescontoNecessaria() {
    const descontoSalvar = Number(
      String(metaDesconto ?? '0').replaceAll(',', '.') ?? 0,
    );

    if (descontoSalvar > Number(descontoMaximo ?? 0)) {
      const valor = await Swal.fire({
        title: `Desconto precisa de aprovação`,
        html: `<div style='text-align: justify!important; text-justify: inter-word;'>
            O percentual informado (${descontoSalvar}%) excede o máximo permitido (<u>menor que</u> ${descontoMaximo}%) para o perfil.
            <br /><br />Ao prosseguir, o efetivo uso desse percentual passará por uma aprovação.
            A proposta ficará bloqueada enquanto aguarda uma resposta dos aprovadores.
            <br /><br />Você será informado por e-mail caso seja aprovado ou reprovado. Deseja prosseguir?</div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, prosseguir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      });
      return { aprovacao: true, salvar: valor.isConfirmed };
    }

    return { aprovacao: false, salvar: true };
  }

  async function handleUpdateDescontoSelecionado(descontoEnviar: string) {
    const descontoSalvar = Number(descontoEnviar?.replaceAll(',', '.') ?? 0);

    Swal.fire({
      icon: 'info',
      text: `Atualizando o desconto`,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
    try {
      const retorno = await api.put(`/proposta/versao/${propostaVersao.id}`, {
        desconto: descontoSalvar,
      });

      return retorno.data;
    } catch (error: any) {
      let mensagem = error?.response?.data?.message;

      if (!mensagem) {
        mensagem = error?.message;
      }
      console.log(mensagem ?? 'Não foi possível salvar o desconto');
      throw error;
    }
  }

  async function processoSalvarDesconto() {
    try {
      let salvarDesconto: { aprovacao: boolean; salvar: boolean } = {
        aprovacao: false,
        salvar: false,
      };

      salvarDesconto = await checkAprovacaoDescontoNecessaria();

      // let recalcular = true;
      if (salvarDesconto.salvar) {
        await handleUpdateDescontoSelecionado(String(metaDesconto ?? 0));

        Swal.fire({
          icon: 'info',
          text: `Recalculando proposta`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });
        // Dispara processo para recalcular, após salvar.
        await api.post(`/proposta/versao/${propostaVersao.id}/recalcular`, {
          isAtingirMeta,
        });
      }

      carregaPropostaVersao();
      Swal.close();
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: error?.response?.data?.message,
      });
    }
  }

  // console.log({
  //   comissaoUsar,
  // });

  async function salvarValoresPrazoMedio(podeDispararAprovacao = false) {
    /**
     *
    if (parcelasModificadas) {
      // Percorrer as parcelas e validar elas antes de salvar.

      const parcelasIncompletas = informacaoProposta?.parcelas.filter(
        (item: any) =>
        !item.meioPagamentoId ||
        !item.percentual ||
        !item.dataPrevista ||
        !item.observacao,
      );

      if (parcelasIncompletas && parcelasIncompletas.length > 0) {
        Swal.fire({
          icon: 'error',
          title: 'Ops!',
          html: 'Um ou mais registros da lista de parcelas estão incompletos. Todos são obrigatórios.',
        });
        return;
      }
    }
    */

    const valor = await Swal.fire({
      title: `Substituir valores salvos`,
      html: `<div style='text-align: justify!important; text-justify: inter-word;'>
          As informações de Data de Embarque, Dias da Base de Juros e Juros irão sobrescrever os valores salvos anteriormente para a proposta.
          ${
            isModoSimulacao
              ? `<br /><br /><strong>Você está em modo de simulação. Ao salvar, o percentual de desconto indicado será aplicado em toda a proposta. </strong><br />`
              : ``
          }

          <br /><br /><strong>Se houve modificação nas parcelas. Ao salvar, as parcelas que foram definidas no Analisador passarão a ser as válidas na proposta.</strong><br />

          <br />Deseja prosseguir?</div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, prosseguir`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    });

    if (valor.isConfirmed) {
      try {
        // Colocar o processo para salvar
        setIsSaving(true);

        Swal.fire({
          icon: 'info',
          text: `Salvando informações...`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        const metaValorValue = Number(
          String(metaValor ?? '0')
            .replace('R$', '')
            .trim()
            .replaceAll('.', '')
            .replaceAll(',', '.'),
        );

        // buscar comissão
        const comissaoUsar = informacaoProposta?.outros?.isRegramentoGeral
          ? comissao
          : resultadoAnalitica.find(item => item.item === 'Comissão Calculada')
              ?.tabelas[0].percentualROB ?? 0;

        const items = resultadoSintetica.filter(
          item => item.conta === CONTA_PROD || item.conta === CONTA_SERV,
        );
        const materiaisServicos = items.map(item => {
          return item.tabelas.map(it => {
            return {
              valor: it.valor,
              percentual: it.percentualMaterialServico,
              produtoId: it.produtoId,
              titulo: item.conta,
            };
          });
        });

        const retorno = await api.put(`/proposta-resultado/salvar-analisador`, {
          propostaVersaoId: propostaVersao.id,
          jurosMensal,
          diasAntesEmbarque,
          dataEmbarque,
          custoFinanceiro,
          PMR,
          parcelas: informacaoProposta?.parcelas ?? [],
          parcelasModificadas: !informacaoProposta?.aprovacao.parcelaAprovada,
          metaValor: metaValorValue,
          isAtingirMeta,
          metaDesconto,
          podeDispararAprovacao,
          comissao: comissaoUsar,
          descontoModificado: metaDesconto !== (propostaVersao?.desconto ?? 0),
          // comissao: resultadoAnalitica.find(
          //   it => it.item.toUpperCase() === 'COMISSÃO CALCULADA',
          // )?.percentualROB,
          parcelaAprovada:
            informacaoProposta?.aprovacao.parcelaAprovada ?? false,
          materiaisServicos,
          tipoArredondamento: informacaoProposta?.outros?.tipoArredondamento,
        });

        const temAprovacao = retorno.data.possuiAprovacao as boolean;

        if (temAprovacao) {
          const valorRetorno = await Swal.fire({
            title: `Aprovações necessárias`,
            html: `<div style='text-align: justify!important; text-justify: inter-word;'>
                  <p>Algumas informações estão fora do permitido. Sendo necessárias passarem por fluxo de aprovação:</p>
                  ${retorno.data.mensagem ?? ''}
                  <br /><br /><p>Deseja prosseguir com o salvamento?</p></div>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Sim, prosseguir`,
            confirmButtonColor: '#d33',
            cancelButtonText: `Não`,
          });

          if (valorRetorno.isConfirmed) {
            await salvarValoresPrazoMedio(true);
          }
        } else {
          // await carregarParcelas();
          setIsModoSimulacao(false);
          setIsModoSimulacaoForm(false);
          carregaPropostaVersao();
          toast.success('Informações salvas com sucesso');
        }

        // toast.success('Informações salvas com sucesso');
        setIsSaving(false);
        setPrecisaSalvar(false);
        Swal.close();
      } finally {
        setIsSaving(false);
        setIsModoSimulacaoForm(false);
      }
    }
  }

  async function handleCalcularSimulador(tipo: string) {
    if (informacaoProposta?.parcelas.length === 0 || !informacaoProposta) {
      Swal.fire({
        title: `Sem parcelas`,
        text: `Deve ser informado algum registro de parcela.`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#d33',
      });
      return;
    }
    const atingirMeta = tipo === 'V';
    const propostaDados: iPropostaDados = {
      ...informacaoProposta,
      metas: {
        ...informacaoProposta.metas,
        metaValor: Number(
          String(metaValor ?? '0')
            .replace('R$', '')
            .trim()
            .replaceAll('.', '')
            .replaceAll(',', '.'),
        ),
        metaDesconto,
        // meta ebitda é tratada como desconto
        tipoMeta: tipo === 'E' ? 'D' : tipo,
      },
    };

    const items = resultadoSintetica.filter(
      item => item.conta === CONTA_PROD || item.conta === CONTA_SERV,
    );
    const materiaisServicos = items.map(item => {
      return item.tabelas.map(it => {
        return {
          valor: it.valor,
          percentual: it.percentualMaterialServico,
          produtoId: it.produtoId,
          titulo: item.conta,
        };
      });
    });
    setIsLoading(true);
    setIsLoadingSintetica(true);
    setRecalcularCustoFinanceiro(false);
    setIsLoadingAnalitica(true);
    setIsLoadingAtividade(true);
    // if (informacaoProposta?.outros?.isRegramentoGeral) {
    //   informacaoProposta.variaveisComerciais.custoFinanceiro = custoFinanceiro;
    //   informacaoProposta.valores.comissao = comissao;
    //   informacaoProposta.valores.percentualComissao = comissao;
    // }

    const toastId = toast.loading('Calculando...');
    try {
      const comissaoUsar = informacaoProposta?.outros?.isRegramentoGeral
        ? comissao
        : resultadoAnalitica.find(item => item.item === 'Comissão Calculada')
            ?.tabelas[0].percentualROB ?? 0;
      let descontoCalcular = metaDesconto;
      let percentMetaEbitda = 0;

      if (tipo === 'R') {
        descontoCalcular = propostaVersao?.desconto ?? 0;
      }

      if (tipo === 'E') {
        // Rodar o cálculo do ebitda para obter o percentual
        const response = await api.post(`/proposta-resultado/calcular`, {
          percentual: metaEbitda ?? 0,
          custoModificado: true,
          isEbitdaMeta: true,
          novoCusto: custoFinanceiro,
          isAtingirMeta: atingirMeta,
          tipo: 'E',
          comissao: comissaoUsar,
          materiaisServicos,
          propostaDados,
        });

        descontoCalcular = response.data.percentual ?? 0;
        percentMetaEbitda = response.data.metaEbitda;
        setMetaDesconto(descontoCalcular);

        // Meta ebitda vai trazer o melhor desconto possível, logo o erro abaixo não é mais necessário
        // if (descontoCalcular === 0) {
        //   Swal.fire({
        //     title: `Ebitda`,
        //     html: `<div style='text-align: justify!important; text-justify: inter-word;'>
        //         Não foi possível encontrar um desconto que gerasse o ebitda solicitado</div>`,
        //     icon: 'warning',
        //     showCancelButton: false,
        //     confirmButtonColor: '#d33',
        //   });
        //   return;
        // }
      }

      // acha o desconto
      if (tipo === 'V') {
        setIsAtingirMeta(true);
        // Rodar o cálculo do ebitda para obter o percentual
        const response = await api.post(`/proposta-resultado/calcular`, {
          custoModificado: true,
          novoCusto: custoFinanceiro,
          percentual: Number(
            String(metaValor ?? '0')
              .replace('R$', '')
              .trim()
              .replaceAll('.', '')
              .replaceAll(',', '.'),
          ),
          tipo: 'V',
          comissao: comissaoUsar,
          materiaisServicos,
          propostaDados,
        });

        descontoCalcular = response.data.percentual ?? 0;
        // setMetaDesconto(descontoCalcular);
      }

      // conseguiu atingir a meta corretamente
      const responseAt = await api.post(`/proposta-resultado/calcular`, {
        custoModificado: true,
        novoCusto: custoFinanceiro,
        percentual: descontoCalcular,
        percentMetaEbitda,
        isEbitdaMeta: false,
        tipo: 'D',
        calculo: 'AT',
        comissao: comissaoUsar,
        materiaisServicos,
        propostaDados,
      });

      if (atingirMeta) {
        descontoCalcular = responseAt.data.desconto ?? 0;
        setMetaDesconto(descontoCalcular);
      }

      setResultadoAtividade(responseAt.data.retorno);

      // conseguiu atingir a meta corretamente
      const responseS = await api.post(`/proposta-resultado/calcular`, {
        percentual: descontoCalcular,
        custoModificado: true,
        novoCusto: custoFinanceiro,
        percentMetaEbitda,
        isEbitdaMeta: false,
        tipo: 'D',
        calculo: 'S',
        comissao: comissaoUsar,
        materiaisServicos,
        propostaDados,
      });

      const dadosSint = (responseS.data ?? []) as RetornoAnaliticaFinal[];
      setResultadoSintetica(
        dadosSint.map(item => {
          return {
            ...item,
            tabelas: item.tabelas.reverse(),
          };
        }),
      );

      // conseguiu atingir a meta corretamente
      const responseA = await api.post(`/proposta-resultado/calcular`, {
        percentual: descontoCalcular,
        custoModificado: true,
        novoCusto: custoFinanceiro,
        percentMetaEbitda,
        isEbitdaMeta: false,
        tipo: 'D',
        calculo: 'A',
        comissao: comissaoUsar,
        materiaisServicos,
        propostaDados,
      });

      const comissaoVal = responseA.data.find(
        (val: any) => val.item === 'Comissão Calculada',
      );

      setComissao(
        comissaoVal.tabelas.find((item: any) => item.titulo.trim() === 'Total')
          .percentualROB,
      );

      const retornoAnalitica = (responseA.data ?? []) as RetornoAnaliticaNovo[];
      setResultadoAnalitica(
        retornoAnalitica.map(item => {
          return {
            ...item,
            tabelas: item.tabelas.reverse(),
          };
        }),
      );

      // get parcelas

      const tPropostaParcelas = informacaoProposta?.parcelas ?? [];
      // const tPropostaParcelas = propostaVersaoParcelas;

      // Pega o novo valor
      const valor =
        dadosSint.find(item => item.conta === 'Receita Bruta')?.tabelas[0]
          .valor ?? 0;
      // const valor = dadosSint.find(item => item.conta === 'Receita Bruta')?.valor ?? 0;

      const valorTotal = valor; // Total da proposta

      const isComFinanciamento = propostaVersao.meioPagamentoId === 3;

      const recursoProprioTotal = isComFinanciamento
        ? tPropostaParcelas.reduce(
            (acc, it) =>
              acc +
              (meioPagamentos.find(
                item => item.financiado && item.id === it.meioPagamentoId,
              )
                ? 0
                : (valorTotal * (it.percentual ?? 0)) / 100),
            0,
          )
        : 0;

      const novoValorTotal = valorTotal - recursoProprioTotal;

      const parcelasNovo: iPropostaVersaoParcelas[] = tPropostaParcelas.map(
        it => {
          return {
            ...it,
            valor: meioPagamentos.find(
              item => item.financiado && item.id === it.meioPagamentoId,
            )
              ? (novoValorTotal * (it.percentual ?? 0)) / 100
              : (valorTotal * (it.percentual ?? 0)) / 100,
          };
        },
      );

      // setPropostaVersaoParcelas(parcelasNovo);

      const parcelasFormatadas = formatarParcelas(parcelasNovo);
      if (informacaoProposta) {
        const novaPropostaValores: iPropostaDados = {
          ...informacaoProposta,
          parcelas: parcelasFormatadas,
          valores: {
            ...informacaoProposta.valores,
            valorFinal: valorTotal,
            valorFinalComOutros: valorTotal,
            valorFinalParcelas: valorTotal,
          },
        };

        handleChange(novaPropostaValores);
        /**
         *
        setInformacaoProposta({
          ...informacaoProposta,
          parcelas: parcelasFormatadas,
          valores: {
            ...informacaoProposta.valores,
            valorFinal: valorTotal,
          },
        });
        */
      }

      setRecalcularCustoFinanceiro(true);
      setMaterialServicoVlrMudou(false);

      toast.success('Cálculo concluído');
    } catch (e: any) {
      console.log(e);
    } finally {
      toast.dismiss(toastId);
      setIsLoadingAtividade(false);
      setIsLoadingAnalitica(false);
      setIsLoadingSintetica(false);
      setIsLoading(false);
    }
  }

  async function handleSimulationMode(open: boolean) {
    if (open) {
      toast.success(
        'Modo de Simulação iniciado. Utilize o botão "Simulador" no canto inferior direito para ocultar/mostrar as ações de simulação.',
        {
          duration: 5000,
        },
      );
      setIsModoSimulacao(open);
      setIsModoSimulacaoForm(open);
    } else {
      const valor = await Swal.fire({
        title: `Sair modo simulação`,
        html: `<div style='text-align: justify!important; text-justify: inter-word;'>
            Você está no modo de simulação. Quaisquer alterações serão perdidas. A tela será atualizada para mostrar os dados originais. Deseja prosseguir?</div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, prosseguir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      });

      if (valor.isConfirmed) {
        setIsModoSimulacao(false);
        setIsModoSimulacaoForm(false);

        setMetaDesconto(propostaVersao?.desconto ?? 0);
        setMetaValor(formatCurrency(propostaVersao?.valorFinal ?? 0, 2));
        setMetaEbitda(0);

        // await carregarParcelas();
        await carregarDadosBasicos();
        await handleCalcularSimulador('R');
      }
    }
  }

  async function recalcularCusto() {
    setIsLoading(true);

    const isComFinanciamento = propostaVersao.meioPagamentoId === 3;

    const toastId = toast.loading('Calculando...');

    const dadosSint = await carregarDadosSintetica();
    await carregarDadosAnalitica();
    await carregarDadosAtividade();

    const tPropostaParcelas = informacaoProposta?.parcelas ?? [];

    const total =
      dadosSint.find(item => item.conta === 'Receita Bruta')?.tabelas[0]
        .valor ?? 0;

    // Pega o novo valor
    // const valor = dadosSint.find(item => item.conta === 'Receita Bruta')?.valor ?? 0;
    const valor = total;

    const valorTotal = valor; // Total da proposta

    const recursoProprioTotal = isComFinanciamento
      ? tPropostaParcelas.reduce(
          (acc, it) =>
            acc +
            (meioPagamentos.find(
              item => item.financiado && item.id === it.meioPagamentoId,
            )
              ? 0
              : (valorTotal * (it.percentual ?? 0)) / 100),
          0,
        )
      : 0;

    const novoValorTotal = valorTotal - recursoProprioTotal;

    const parcelasNovo: iPropostaVersaoParcelas[] = tPropostaParcelas.map(
      it => {
        return {
          ...it,
          valor: meioPagamentos.find(
            item => item.financiado && item.id === it.meioPagamentoId,
          )
            ? (novoValorTotal * (it.percentual ?? 0)) / 100
            : (valorTotal * (it.percentual ?? 0)) / 100,
        };
      },
    );

    // setPropostaVersaoParcelas(parcelasNovo);
    const parcelasFormatadas = formatarParcelas(parcelasNovo);
    if (informacaoProposta) {
      const novaPropostaValores: iPropostaDados = {
        ...informacaoProposta,
        parcelas: parcelasFormatadas,
        valores: {
          ...informacaoProposta.valores,
          valorFinal: valorTotal,
        },
      };

      handleChange(novaPropostaValores);
    }
    setIsLoading(false);
    setCustoChanged(false);
    toast.dismiss(toastId);
  }

  async function handleRecalculate() {
    let textoMeta = 'meta de desconto';
    let qualMetaUsar = 'D';
    let valorUsar = `${metaDesconto}%`;

    if (isAtingirMeta) {
      textoMeta = 'meta de valor';
      qualMetaUsar = 'V';
      valorUsar = metaValor.replace('R$', '').trim();
    } else if (isAtingirMetaEbitda) {
      textoMeta = 'meta de ebitda';
      qualMetaUsar = 'E';
      valorUsar = `${metaEbitda}%`;
    }
    Swal.fire({
      title: `Atingir ${textoMeta}`,
      text: `Deseja atingir ${textoMeta} com o valor de ${valorUsar}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(result => {
      if (result.isConfirmed) {
        handleCalcularSimulador(qualMetaUsar);
      }
    });
  }

  return (
    <>
      <Card className="shadow mt-1 mb-1">
        <CardBody>
          {
            // {apenasSintetica === true}
          }

          <Row className="ml-1" hidden={!isPrecificacaoLegacy}>
            <Col sm="12">
              <Alert color="danger" style={{ fontSize: '1.2rem' }}>
                Houveram mudanças nos cálculos da precificação, os valores
                calculados nesta proposta não vão refletir corretamente os dados
                atuais.
              </Alert>
            </Col>
          </Row>

          {isModoSimulacaoForm && (
            <Navbar
              className="bg-white"
              style={{
                position: 'fixed',
                flexDirection: 'column',
                top: 0,
                right: 0,
                width: '45vw',
                height: '100vh',
                zIndex: 1050,
                transition: 'transform .3s ease',
                transform: isModoSimulacaoForm
                  ? 'translateX(0)'
                  : 'translateX(100%)',
                boxShadow: '-4px 0 12px rgba(0,0,0,.2)',
                overflowY: 'auto',
              }}
            >
              {isModoSimulacaoForm && (
                <>
                  <div
                    className="space-y-1"
                    style={{
                      flex: 1,
                      overflowY: 'auto',
                      padding: 24,
                    }}
                  >
                    <Row>
                      <Col sm="12">
                        <h4>Modo de Simulação</h4>
                        <p>
                          <small>
                            Ajuste os campos para simular o comportamento da
                            proposta. As alterações só afetarão a proposta após
                            clicar em{' '}
                            <span style={{ fontWeight: 'bold' }}>Salvar</span>.
                          </small>
                        </p>
                        <InputGroup className="mb-1">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="form-control-sm">
                              Meta Desconto (%)
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            value={metaDesconto ?? 0}
                            type="number"
                            onChange={text => {
                              const descontoUsar = Number(
                                text.target.value ?? 0,
                              );
                              setIsAtingirMeta(false);
                              setMetaDesconto(descontoUsar);
                              setIsAtingirMetaEbitda(false);
                            }}
                            disabled={isLoading}
                            className="form-control-sm"
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="primary"
                              className="btn-icon btn-2"
                              type="button"
                              outline
                              size="sm"
                              onClick={() => {
                                handleCalcularSimulador('D');
                              }}
                              disabled={isLoading}
                              title="Calcular o analisador utilizando essas informações"
                            >
                              <FaCalculator />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>

                        <InputGroup className="mb-1">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="form-control-sm">
                              Meta Ebitda (%)
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            value={metaEbitda ?? 0}
                            type="number"
                            onChange={text => {
                              const ebitdaUsar = Number(text.target.value ?? 0);
                              setIsAtingirMeta(false);
                              setMetaEbitda(ebitdaUsar);
                              setIsAtingirMetaEbitda(true);
                            }}
                            disabled={isLoading}
                            className="form-control-sm"
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="primary"
                              className="btn-icon btn-2"
                              type="button"
                              outline
                              size="sm"
                              onClick={() => {
                                handleCalcularSimulador('E');
                              }}
                              disabled={isLoading}
                              title="Calcular o analisador utilizando essas informações"
                            >
                              <FaCalculator />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                        <InputGroup className="mb-1">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="form-control-sm">
                              Meta Valor Bruto (R$)
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="text"
                            value={metaValor.replace('R$', '').trim()}
                            onBlur={text => {
                              const convertido = String(
                                text.target.value ?? '0',
                              )
                                .replaceAll('.', '')
                                .replaceAll(',', '.');
                              setMetaValor(
                                formatCurrency(Number(convertido), 2),
                              );
                            }}
                            onChange={text => {
                              const convertido = String(
                                text.target.value ?? '0',
                              )
                                .replaceAll('.', '')
                                .replaceAll(',', '.');

                              setIsAtingirMeta(true);
                              setIsAtingirMetaEbitda(false);

                              // handleChange({
                              //   ...informacaoProposta!,
                              //   metas: {
                              //     ...informacaoProposta?.metas,
                              //     tipoMeta: 'V',
                              //     metaValor: Number(
                              //       convertido.replace('.', ','),
                              //     ),
                              //   },
                              // });

                              setMetaValor(convertido.replace('.', ','));
                            }}
                            disabled={isLoading}
                            className="form-control-sm"
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="primary"
                              className="btn-icon btn-2"
                              type="button"
                              outline
                              size="sm"
                              onClick={() => {
                                handleCalcularSimulador('V');
                              }}
                              disabled={isLoading}
                              title="Calcular o analisador utilizando essas informações"
                            >
                              <FaCalculator />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                        <InputGroup>
                          <InputGroupAddon
                            addonType="prepend"
                            style={{ width: '100%' }}
                            className="mt-2 mb-2"
                          >
                            {informacaoProposta && (
                              <SelecaoArredondamento
                                informacaoProposta={informacaoProposta!}
                                isModoSimulacao={isModoSimulacao}
                                onChange={handleChange}
                                isLoading={isLoading}
                              />
                            )}
                          </InputGroupAddon>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row hidden={!(apenasSintetica === false)} className="mt-2">
                      <Col sm="6">
                        {' '}
                        <Row className="ml-0">
                          <h6 className="heading-small text-muted ml-0">
                            Prazo Médio de Recebimento
                            {isLoadingSintetica && (
                              <CircularProgress
                                className="mt-2 ml-0"
                                color="inherit"
                                size={10}
                              />
                            )}
                          </h6>
                        </Row>
                      </Col>
                      <Col sm="6">
                        <Button
                          size="sm"
                          className="btn-icon float-right mr-0"
                          color="warning"
                          type="button"
                          hidden={
                            !custoChanged ||
                            informacaoProposta?.outros?.isRegramentoGeral
                          }
                          disabled={isSaving || isLoadingPrazoMedio}
                          onClick={recalcularCusto}
                        >
                          <span className="btn-inner--text">
                            Calcular com novo Custo Financeiro
                          </span>
                        </Button>
                      </Col>

                      <Col sm="12">
                        <>
                          <Row>
                            <Col sm="6">
                              <strong>Data Embarque:</strong>
                              <DatePicker
                                locale="pt-BR"
                                dateFormat="dd/MM/yyyy"
                                className="form-control-sm"
                                showIcon
                                disabled={
                                  !acessoProgramas.find(
                                    item =>
                                      item.programa === 80 &&
                                      item.temAcesso === true &&
                                      item.acessoLimitado === false,
                                  ) || isLoading
                                }
                                selected={dataEmbarque}
                                onChange={event =>
                                  atualizarDados('data_embarque', event)
                                }
                              />
                              <small>
                                {diasParaEmbarque} dias para embarque
                              </small>
                            </Col>
                            <Col sm="6">
                              <strong>Dias do Embarque:</strong>
                              <Input
                                type="number"
                                value={diasAntesEmbarque ?? 0}
                                disabled={
                                  !acessoProgramas.find(
                                    item =>
                                      item.programa === 82 &&
                                      item.temAcesso === true &&
                                      item.acessoLimitado === false,
                                  ) || isLoading
                                }
                                className="form-control-sm"
                                onChange={event => {
                                  atualizarDados(
                                    'dias_antes_embarque',
                                    Number(event.target.value),
                                  );
                                }}
                              />
                              <small>
                                Data Base Juros: {dataBaseJurosEmbarque}
                              </small>
                            </Col>
                          </Row>

                          <Row className="mt-1">
                            <Col sm="6">
                              <strong>Custo financeiro no período</strong>
                              <Input
                                type="number"
                                value={custoFinanceiro ?? 0}
                                className="form-control-sm"
                                onChange={event => {
                                  setCustoFinanceiro(
                                    Number(event.target.value),
                                  );

                                  setInformacaoProposta(
                                    (prev: iPropostaDados | undefined) => {
                                      if (!prev) return undefined;
                                      return {
                                        ...prev,
                                        variaveisComerciais: {
                                          ...prev?.variaveisComerciais,
                                          custoFinanceiro,
                                        },
                                      };
                                    },
                                  );
                                }}
                                disabled={
                                  !acessoProgramas.find(
                                    item =>
                                      item.programa === 131 &&
                                      item.temAcesso === true,
                                  ) || isLoading
                                }
                              />
                            </Col>
                            <Col sm="6">
                              <strong>Comissão:</strong>
                              <Input
                                type="number"
                                value={comissao ?? 0}
                                className="form-control-sm"
                                onChange={event => {
                                  setComissao(Number(event.target.value));

                                  setInformacaoProposta(
                                    (prev: iPropostaDados | undefined) => {
                                      if (!prev) return undefined;
                                      return {
                                        ...prev,
                                        valores: {
                                          ...prev?.valores,
                                          comissao,
                                          percentualComissao: comissao,
                                        },
                                        variaveisComerciais: {
                                          ...prev?.variaveisComerciais,
                                          custoFinanceiro,
                                        },
                                      };
                                    },
                                  );
                                }}
                                disabled={
                                  !acessoProgramas.find(
                                    item =>
                                      item.programa === 131 &&
                                      item.temAcesso === true,
                                  ) || isLoading
                                }
                              />{' '}
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              sm="6"
                              hidden={
                                !acessoProgramas.find(
                                  item =>
                                    item.programa === 81 &&
                                    item.temAcesso === true,
                                ) ||
                                informacaoProposta?.outros?.isRegramentoGeral
                                // ||
                                // !acessoProgramas.find(
                                //   item =>
                                //     item.programa === 131 &&
                                //     item.temAcesso === true,
                                // )
                              }
                            >
                              <strong>
                                Juros a.m. (a partir da data base)
                              </strong>
                              <Input
                                type="number"
                                className="form-control-sm"
                                value={jurosMensal ?? 0}
                                onChange={event =>
                                  atualizarDados(
                                    'juros_mensal',
                                    event.target.value,
                                  )
                                }
                                hidden={
                                  informacaoProposta?.outros?.isRegramentoGeral
                                }
                                disabled={
                                  !acessoProgramas.find(
                                    item =>
                                      item.programa === 81 &&
                                      item.temAcesso === true &&
                                      item.acessoLimitado === false,
                                  )
                                }
                              />
                            </Col>
                            <Col sm="6">
                              <strong>PMR:</strong> {PMR} dias da data base
                            </Col>
                          </Row>

                          <Row>
                            {informacaoProposta && (
                              <Parcelas
                                propostaVersao={informacaoProposta}
                                isModoSimulacao={isModoSimulacao}
                                onChange={handleChange}
                                isAnalisador
                                setCustoChanged={setCustoChanged}
                                isLoading={isLoading}
                              />
                            )}
                          </Row>

                          <Row>{/* criarTabela(propostaVersaoParcelas) */}</Row>
                        </>
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      padding: 14,
                      borderTop: '1px solid #ddd',
                      background: '#fff',
                      flexShrink: 0,
                    }}
                  >
                    <Row>
                      <Col sm="6">
                        <Button
                          className="btn-icon"
                          color="danger"
                          type="button"
                          title="Cancelar simulação"
                          hidden={!isModoSimulacao}
                          disabled={
                            isSaving || isLoading || isLoadingPrazoMedio
                          }
                          onClick={() => handleSimulationMode(!isModoSimulacao)}
                        >
                          <span className="btn-inner--text">Cancelar</span>
                        </Button>
                      </Col>
                      <Col sm="6">
                        <Button
                          className="btn-icon float-right mr-0"
                          color="warning"
                          type="button"
                          title="Salvar informações"
                          // hidden={!precisaSalvar}
                          disabled={
                            isSaving ||
                            isLoading ||
                            isLoadingPrazoMedio ||
                            (custoChanged &&
                              !informacaoProposta?.outros?.isRegramentoGeral)
                          }
                          onClick={() => salvarValoresPrazoMedio()}
                        >
                          <span className="btn-inner--text">Salvar</span>
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </Navbar>
          )}

          {apenasSintetica === false && (
            <>
              <Alert
                color="warning"
                hidden={!isModoSimulacao}
                className="custom-alert"
              >
                <Row className="ml-1">
                  <Col sm="8">
                    Estando em modo de simulação, as alterações só terão efeito
                    após salvar.
                  </Col>
                  <Col sm="4">
                    <Button
                      size="sm"
                      className="btn-icon float-right"
                      color="danger"
                      type="button"
                      disabled={isSaving}
                      onClick={() => handleSimulationMode(!isModoSimulacao)}
                    >
                      <span className="btn-inner--text">
                        Cancelar Simulação
                      </span>
                    </Button>
                  </Col>
                </Row>
              </Alert>
              <Row>
                <Col sm="8">
                  <Button
                    size="sm"
                    className="btn-icon"
                    color="info"
                    type="button"
                    hidden={isModoSimulacao}
                    disabled={isSaving}
                    onClick={() => handleSimulationMode(!isModoSimulacao)}
                  >
                    <span className="btn-inner--text">
                      Iniciar Modo Simulação
                    </span>
                  </Button>
                  <Button
                    size="sm"
                    className="btn-icon"
                    color="danger"
                    type="button"
                    hidden
                    disabled={isSaving}
                    onClick={() => handleSimulationMode(!isModoSimulacao)}
                  >
                    <span className="btn-inner--text">Cancelar Simulação</span>
                  </Button>
                </Col>
                <Col sm="4">
                  <Button
                    size="sm"
                    className="btn-icon float-right mr-0"
                    color="warning"
                    type="button"
                    hidden
                    disabled={isSaving || isLoadingPrazoMedio || custoChanged}
                    onClick={() => salvarValoresPrazoMedio()}
                  >
                    <span className="btn-inner--text">Salvar Informações</span>
                  </Button>
                </Col>
              </Row>
            </>
          )}
          {valoresDiferentes && (
            <Row className="mt-2">
              <Col sm="12" xs="12">
                <Alert color="danger">
                  O somatório das parcelas é diferente do Valor Bruto. Por
                  favor, revise-as.
                </Alert>
              </Col>
            </Row>
          )}

          <Row>
            <Col sm="12">
              <Row className="ml-0 mt-1">
                <h6 className="heading-small text-muted mb-1">
                  Visão Sintética
                </h6>
                {isLoadingSintetica && (
                  <CircularProgress
                    className="mt-2 ml-2"
                    color="inherit"
                    size={10}
                  />
                )}
              </Row>
              <hr className="custom-hr mt-1" />

              <Table
                responsive
                bordered
                className={`tabela ${
                  resultadoSintetica?.[0]?.tabelas.length > 3
                    ? `tabela-full`
                    : `tabela-without-width`
                }`}
              >
                <thead>
                  <tr>
                    <Th
                      style={{
                        position: 'sticky',
                        left: 0,
                        zIndex: 2,
                        background: 'white',
                      }}
                    >
                      {/* Título da coluna fixa (deixar vazio) */}
                    </Th>

                    {resultadoSintetica &&
                      Array.isArray(resultadoSintetica) &&
                      resultadoSintetica[0]?.tabelas.map((val, index) => (
                        <Th
                          key={`top-${index}`}
                          colSpan={tabelasLimitadas ? 1 : 2}
                          style={{
                            textAlign: 'center',
                            borderRight: '2px solid black',
                          }}
                        >
                          {val?.titulo ?? ''}
                        </Th>
                      ))}
                  </tr>

                  <tr>
                    {/* Coluna fixa */}
                    <Th
                      style={{
                        position: 'sticky',
                        left: 0,
                        zIndex: 2,
                        background: 'white',
                        width: '10vw',
                      }}
                    >
                      Conta
                    </Th>

                    {resultadoSintetica &&
                      Array.isArray(resultadoSintetica) &&
                      resultadoSintetica[0]?.tabelas?.map((val, index) => (
                        <React.Fragment key={`sub-${index}`}>
                          <Th>Valores</Th>
                          {!tabelasLimitadas && (
                            <Th
                              style={{
                                borderRight: '2px solid black',
                              }}
                            >
                              % / ROL
                            </Th>
                          )}
                        </React.Fragment>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {resultadoSintetica
                    .filter(item =>
                      tabelasLimitadas ? item.limitar === false : true,
                    )
                    .map((linha, index) => {
                      const { conta, tabelas } = linha;

                      return (
                        <tr key={index}>
                          {/* COLUNA FIXA */}
                          <Td
                            style={{
                              position: 'sticky',
                              left: 0,
                              zIndex: 2,
                              background: 'white',
                            }}
                          >
                            <strong>{conta}</strong>
                          </Td>

                          {/* PARA CADA TABELA, CRIA 2 COLUNAS */}
                          {tabelas.map((t: RetornoTabela, i: number) => {
                            return (
                              <React.Fragment key={i}>
                                <Td
                                  className={`text-right ${
                                    String(t.titulo).trim() === 'Total'
                                      ? `tbl-total`
                                      : ``
                                  }`}
                                  style={{
                                    visibility:
                                      t.percentualROL === null
                                        ? 'hidden'
                                        : 'visible',
                                  }}
                                >
                                  {t.editavel ? (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                        gap: 8,
                                      }}
                                    >
                                      <strong
                                        style={{
                                          width: `${t.valor ? '' : '4rem'}`,
                                        }}
                                      >
                                        {t.valor !== null ? (
                                          formatCurrency(t.valor)
                                        ) : (
                                          <Tooltip
                                            className="mr-2"
                                            title="A proporção de materiais e serviços mudou, este valor será alterado no recalculo."
                                          >
                                            <IconButton>
                                              <FaInfoCircle
                                                size={12}
                                                color="#888787"
                                              />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                      </strong>
                                      <strong>
                                        <InputGroup
                                          size="sm"
                                          style={{ width: 100 }}
                                        >
                                          <Input
                                            type="number"
                                            min={0}
                                            max={100}
                                            step={0.01}
                                            className="text-right"
                                            value={
                                              t.percentualMaterialServico ?? 0
                                            }
                                            onChange={e => {
                                              let valor = Number(
                                                e.target.value,
                                              );
                                              if (valor < 0) valor = 0;
                                              if (valor > 100) valor = 100;

                                              handleChangePercentual(
                                                index,
                                                i,
                                                valor,
                                              );
                                            }}
                                            style={{
                                              height: '2rem',
                                            }}
                                          />

                                          <InputGroupAddon
                                            style={{
                                              height: '2rem',
                                            }}
                                            addonType="append"
                                          >
                                            <InputGroupText>%</InputGroupText>
                                          </InputGroupAddon>
                                        </InputGroup>
                                      </strong>
                                    </div>
                                  ) : (
                                    <>
                                      <strong
                                        style={{
                                          backgroundColor:
                                            t.isTotal &&
                                            valoresDiferentes &&
                                            conta === 'Receita Bruta'
                                              ? '#dc3545'
                                              : 'transparent',
                                          color:
                                            t.isTotal &&
                                            valoresDiferentes &&
                                            conta === 'Receita Bruta'
                                              ? '#fff'
                                              : 'inherit',
                                          padding: '4px 10px',
                                          borderRadius: '4px',
                                          fontWeight: 600,
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {materialServicoVlrMudou &&
                                        t.isTotal &&
                                        (conta === 'Prod/Mat/Mercad' ||
                                          conta === 'Servico/Engenh/Proj') ? (
                                          <Tooltip
                                            className="mr-2"
                                            title="A proporção de materiais e serviços mudou, o valor total será alterado no recalculo."
                                          >
                                            <IconButton>
                                              <FaInfoCircle
                                                size={12}
                                                color="#888787"
                                              />
                                            </IconButton>
                                          </Tooltip>
                                        ) : (
                                          formatCurrency(t.valor)
                                        )}
                                      </strong>
                                    </>
                                  )}
                                </Td>

                                <Td
                                  className={`text-right ${
                                    String(t.titulo).trim() === 'Total'
                                      ? `tbl-total`
                                      : ``
                                  }`}
                                  style={{
                                    borderRight: '2px solid black',
                                    visibility:
                                      t.percentualROL === null
                                        ? 'hidden'
                                        : 'visible',
                                  }}
                                >
                                  <strong>{t.percentualROL ?? 0}%</strong>
                                </Td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </Col>
          </Row>
          {/* {apenasSintetica === true && */}
          <>
            <Row>
              <Col sm="12">
                <Row className="ml-0 mt-2">
                  <h6 className="heading-small text-muted mb-1">
                    Visão Analítica
                  </h6>
                  {isLoadingAnalitica && (
                    <CircularProgress
                      className="mt-2 "
                      color="inherit"
                      size={10}
                    />
                  )}
                </Row>
                <hr className="custom-hr mt-1" />

                <Table
                  responsive
                  bordered
                  className={`tabela ${
                    resultadoAnalitica?.[0]?.tabelas.length > 3
                      ? `tabela-full`
                      : `tabela-without-width`
                  }`}
                >
                  <thead>
                    <tr>
                      {/* Coluna fixa */}
                      <Th
                        style={{
                          position: 'sticky',
                          left: 0,
                          zIndex: 2,
                          background: 'white',
                          width: '10vw',
                        }}
                      >
                        Item
                      </Th>

                      {resultadoAnalitica[0]?.tabelas.map((t, index) => (
                        <Th
                          key={index}
                          colSpan={tabelasLimitadas ? 1 : 3}
                          style={{
                            textAlign: 'center',
                            borderRight: '2px solid black',
                          }}
                        >
                          {t.titulo}
                        </Th>
                      ))}
                    </tr>

                    {/* SUBCABEÇALHO */}
                    <tr>
                      <Th
                        style={{
                          position: 'sticky',
                          left: 0,
                          zIndex: 2,
                          background: 'white',
                        }}
                      >
                        {/* vazio */}
                      </Th>
                      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                      {/* @ts-ignore */}
                      {resultadoAnalitica[0]?.tabelas.map((t, index) => (
                        <React.Fragment key={index}>
                          <Th>Valores</Th>
                          {!tabelasLimitadas && <Th>% / ROL</Th>}
                          {!tabelasLimitadas && (
                            <Th style={{ borderRight: '2px solid black' }}>
                              % / ROB
                            </Th>
                          )}
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {resultadoAnalitica
                      .filter(l =>
                        tabelasLimitadas ? l.limitar === false : true,
                      )
                      .map((linha, rowIndex) => (
                        <tr
                          key={rowIndex}
                          hidden={!linha.visivel}
                          className={
                            String(linha.item).trim() === 'Total'
                              ? `tbl-total`
                              : ``
                          }
                        >
                          {/* COLUNA FIXA */}
                          <Td
                            style={{
                              position: 'sticky',
                              left: 0,
                              zIndex: 2,
                              background: 'white',
                            }}
                          >
                            <strong>{linha.item}</strong>
                          </Td>

                          {/* PARA CADA TABELA */}
                          {linha.tabelas.map((t, colIndex) => {
                            return (
                              <React.Fragment key={colIndex}>
                                <Td
                                  className={`text-right ${
                                    String(t.titulo).trim() === 'Total'
                                      ? `tbl-total`
                                      : ``
                                  }`}
                                >
                                  <strong style={{ fontWeight: 'bold' }}>
                                    {formatCurrency(t.valor)}
                                  </strong>
                                </Td>

                                {!tabelasLimitadas && (
                                  <Td
                                    className={`text-right ${
                                      String(t.titulo).trim() === 'Total'
                                        ? `tbl-total`
                                        : ``
                                    }`}
                                  >
                                    <strong>{t.percentualROL ?? 0}%</strong>
                                  </Td>
                                )}

                                {!tabelasLimitadas && (
                                  <Td
                                    className={`text-right ${
                                      String(t.titulo).trim() === 'Total'
                                        ? `tbl-total`
                                        : ``
                                    }`}
                                    style={{ borderRight: '2px solid black' }}
                                  >
                                    <strong>{t.percentualROB ?? 0}%</strong>
                                  </Td>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      ))}
                  </tbody>
                </Table>

                <Row className="ml-0 mt-2">
                  <h6 className="heading-small text-muted mb-1">
                    Abertura de Preço por Atividade
                  </h6>
                  {isLoadingAtividade && (
                    <CircularProgress
                      className="mt-2 ml-2"
                      color="inherit"
                      size={10}
                    />
                  )}
                </Row>
              </Col>
            </Row>
            <hr className="custom-hr mt-1" />

            <Table responsive bordered className="tabela tabela-full">
              <thead>
                <tr>
                  <Th>Atividade</Th>
                  <Th>Descrição Atividade</Th>
                  <Th>BDI Total</Th>
                  <Th style={{ backgroundColor: '#17446B', color: '#FFFFFF' }}>
                    Receita Bruta
                  </Th>
                  <Th
                    hidden={tabelasLimitadas}
                    style={{ backgroundColor: '#17446B', color: '#FFFFFF' }}
                  >
                    Preço Líquido
                  </Th>
                  <Th hidden={tabelasLimitadas}>Custo Materiais</Th>
                  <Th hidden={tabelasLimitadas}>% / ROL</Th>
                  <Th hidden={tabelasLimitadas}>Demais CVs</Th>
                  <Th
                    hidden={tabelasLimitadas}
                    style={{ backgroundColor: '#2068A9', color: '#FFFFFF' }}
                  >
                    Margem Cont
                  </Th>
                  <Th
                    hidden={tabelasLimitadas}
                    style={{ backgroundColor: '#2068A9', color: '#FFFFFF' }}
                  >
                    % MC / ROL
                  </Th>
                  <Th hidden={tabelasLimitadas}>% ABC Fat</Th>
                </tr>
              </thead>
              <tbody>
                {resultadoAtividade &&
                  Array.isArray(resultadoAtividade) &&
                  resultadoAtividade?.map((atividade, index) => {
                    const {
                      codigoAtividade,
                      descricaoAtividade,
                      bdiTotal,
                      precoBruto,
                      precoLiquido,
                      custoMateriais,
                      percentualROL,
                      demaisCV,
                      margemCont,
                      percentualMargemROL,
                      abcFat,
                      isTotalRow,
                    } = atividade;

                    const fontWeight = isTotalRow ? 850 : 'normal';
                    return (
                      <tr key={index}>
                        <Td>
                          <Label className="text-muted">
                            <strong>{codigoAtividade}</strong>
                          </Label>
                        </Td>
                        <Td>
                          <Label className="text-muted">
                            <strong style={{ fontWeight }}>
                              {descricaoAtividade}
                            </strong>
                          </Label>
                        </Td>
                        <Td className="text-right">
                          <Label className="text-muted">
                            <strong style={{ fontWeight }}>
                              {formatCurrency(bdiTotal)}
                            </strong>
                          </Label>
                        </Td>
                        <Td
                          className="text-right"
                          style={{ backgroundColor: '#17446B' }}
                        >
                          <Label className="text-muted">
                            <strong style={{ color: '#FFFFFF', fontWeight }}>
                              {formatCurrency(precoBruto)}
                            </strong>
                          </Label>
                        </Td>
                        <Td
                          hidden={tabelasLimitadas}
                          className="text-right"
                          style={{ backgroundColor: '#17446B' }}
                        >
                          <Label className="text-muted">
                            <strong style={{ color: '#FFFFFF', fontWeight }}>
                              {formatCurrency(precoLiquido)}
                            </strong>
                          </Label>
                        </Td>
                        <Td hidden={tabelasLimitadas} className="text-right">
                          <Label className="text-muted">
                            <strong style={{ fontWeight }}>
                              {formatCurrency(custoMateriais)}
                            </strong>
                          </Label>
                        </Td>
                        <Td hidden={tabelasLimitadas} className="text-right">
                          <Label className=" text-muted">
                            <strong style={{ fontWeight }}>
                              {percentualROL} %
                            </strong>
                          </Label>
                        </Td>
                        <Td hidden={tabelasLimitadas} className="text-right">
                          <Label className="text-muted">
                            <strong style={{ fontWeight }}>
                              {formatCurrency(demaisCV)}
                            </strong>
                          </Label>
                        </Td>
                        <Td
                          hidden={tabelasLimitadas}
                          className="text-right"
                          style={{ backgroundColor: '#2068A9' }}
                        >
                          <Label className="text-muted">
                            <strong style={{ fontWeight, color: '#FFFFFF' }}>
                              {formatCurrency(margemCont)}
                            </strong>
                          </Label>
                        </Td>
                        <Td
                          hidden={tabelasLimitadas}
                          className="text-right"
                          style={{ backgroundColor: '#2068A9' }}
                        >
                          <Label className=" text-muted">
                            <strong style={{ fontWeight, color: '#FFFFFF' }}>
                              {percentualMargemROL} %
                            </strong>
                          </Label>
                        </Td>
                        <Td hidden={tabelasLimitadas} className="text-right">
                          <Label className="text-muted">
                            <strong style={{ fontWeight }}>{abcFat} %</strong>
                          </Label>
                        </Td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </>
          {/* } */}
        </CardBody>
      </Card>

      <Container
        className="mb-2"
        style={{ zIndex: 1100 }}
        hidden={!isModoSimulacao}
      >
        <Button
          color="info"
          size="md"
          title="Opções do Simulador"
          onClick={() => {
            setIsModoSimulacao(true);
            setIsModoSimulacaoForm(!isModoSimulacaoForm);
          }}
        >
          {!isModoSimulacaoForm ? <FaEye /> : <FaEyeSlash />} Simulador
        </Button>
      </Container>
    </>
  );
}
